import React from 'react'
import styled from 'styled-components'

import { translate } from '~/core/translate'
import Button from '~/components/common/button'
import Modal from '~/components/common/modal'
import { ColumnFlex } from '~/components/common/containers'
import { hideDialog } from '~/actions/ui'

const Description = styled.div`
  margin-top: 16px;
  display: flex;
  ${({ theme }) => ({ ...theme._neo.body02 })}
`

const NewRoomNameText = styled.div`
  margin-top: 8px;
  ${({ theme }) => ({ ...theme._neo.heading01 })}
  overflow-wrap: break-word;
`

const NewRoomUrlText = styled.div`
  margin-top: 8px;
  ${({ theme }) => ({ ...theme._neo.body02 })}
  color: ${props => props.theme.colorHighlight};
  overflow-wrap: break-word;
`

const StyledButton = styled(Button)`
  min-width: 120px;
`

const ConfirmEditScreen = props => (
  <Modal
    footerChildren={(
      <StyledButton
        onClick={hideDialog}
        variant='secondary'
      >
        {translate('got_it')}
      </StyledButton>
    )}
    title={translate('info_updated')}
  >
    <ColumnFlex>
      <Description>
        {translate('your_new_meeting_name')}
      </Description>
      <NewRoomNameText>
        {props.personalRoom}
      </NewRoomNameText>
      <Description>
        {translate('your_new_meeting_url')}
      </Description>
      <NewRoomUrlText>{props.url}</NewRoomUrlText>
      <Description>
        {translate('confirm_old_url_valid')}
      </Description>
    </ColumnFlex>
  </Modal>
)

export default ConfirmEditScreen
